/** Друкована форма звіту про внесок на підтримку працевлаштування осіб з інвалідністю —
 *  бланк за наказом Мінфіну № 453 на трьох аркушах (ч.1213–1214). Сам бланк —
 *  `DisabilityContributionReportBlank.tsx` (спільний з редактором, ч.1215); тут лише
 *  завантаження полів з `/blank`, панель «друкувати» і правила друку. */
import { useNavigate, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { disabilityContributionReports } from '@/api/disabilityContributionReports';
import { DisabilityReportBlankSheets } from './DisabilityContributionReportBlank';

export default function DisabilityContributionReportPrintPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const blankQ = useQuery({
    queryKey: ['disability-report-blank', id],
    queryFn: () => disabilityContributionReports.blank(id!),
    enabled: !!id,
  });
  const blank = blankQ.data;
  if (blankQ.isError) return <div className="card">Не вдалося завантажити звіт для друку.</div>;
  if (!blank) return <div className="card">Завантаження…</div>;
  return (
    <div style={{ background: '#fff', minHeight: '100vh' }}>
      <style>{`
        @media print {
          .no-print { display: none !important; }
          @page { size: A4 portrait; margin: 1.5cm 0.6cm 1.2cm 1.8cm; }
          .print-page { page-break-before: always; }
          .print-page:first-of-type { page-break-before: auto; }
          nav, aside, header { display: none !important; }
          body { background: #fff !important; }
        }
        @media screen {
          .print-page + .print-page { margin-top: 2.2rem; padding-top: 1.4rem; border-top: 1px dashed #94a3b8; }
        }
      `}</style>
      <div className="no-print" style={{ display: 'flex', gap: '0.5rem', padding: '0.6rem 1rem', borderBottom: '1px solid #e2e8f0', alignItems: 'center', flexWrap: 'wrap' }}>
        <b>Друк: звіт про внесок (особи з інвалідністю) — {blank.period_quarter} квартал {blank.period_year}</b>
        <span style={{ color: '#64748b', fontSize: '0.85rem' }}>
          {blank.form_code} · {blank.form_code === 'J0500701' ? 'для юридичних осіб' : 'для фізичних осіб'}
        </span>
        <div style={{ marginLeft: 'auto', display: 'flex', gap: '0.5rem' }}>
          <button className="primary" onClick={() => window.print()}>друкувати</button>
          <button onClick={() => navigate(`/taxation/disability-contribution-reports/${id}`)}>до звіту</button>
        </div>
      </div>
      {blank.missing.length > 0 && (
        <div className="no-print" style={{ margin: '0.6rem 1rem 0', padding: '0.5rem 0.75rem', background: '#fef3c7', border: '1px solid #f59e0b', color: '#b45309', borderRadius: 6 }}>
          У картці організації не заповнено: {blank.missing.join('; ')}. На бланку ці поля порожні.
        </div>
      )}
      <div style={{ maxWidth: 820, margin: '0 auto', padding: '1.2rem 1rem 2rem' }}>
        <DisabilityReportBlankSheets blank={blank} />
      </div>
    </div>
  );
}
